import Absences from './absences.png';
import Contacts from './contacts.png';
import Commandes from './commandes.png';
import Documents from './documents.png';
import Inscriptions from './inscriptions.png';
import Horaires from './hyperplanning.png';
import MyPrint from './myprint.png';
import Valves from './valves.png';
import WiFi from './wifi.png';
import Mail from './outlook.png';
import Teams from './teams.png';
import Moodle from './moodle.png';
import SignaturePAE from './signature.png';
import Inscription from './inscription.png';
import Stage from './stage.png';
import Memoire from './memoire.png';
import Reinscription from './reinscription.png';
import SAR from './sar.png';
import JobTeaser from './jobteaser.png'
import Proclamation from "./proclamation.png";
import ProclamationBanner from "./proclamationBanner.png";

export default {
    Absences,
    Contacts,
    Commandes,
    Documents,
    Inscriptions,
    Horaires,
    Valves,
    MyPrint,
    WiFi,
    Mail,
    Teams,
    JobTeaser,
    Moodle,
    SignaturePAE,
    Inscription,
    Stage,
    Memoire,
    Reinscription,
    SAR,
    Proclamation,
    ProclamationBanner,
}